var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M256,512c92.24,0,173.235-49.042,218.299-122.416H37.701C82.765,462.958,163.76,512,256,512z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,0C114.841,0,0,114.841,0,256c0,36.523,7.705,71.274,21.547,102.741h4.361v-80.794 c0-48.64,39.572-88.212,88.212-88.212c8.516,0,15.422,6.904,15.422,15.422v79.118h12.587V143.758 c0-8.517,6.906-15.422,15.422-15.422h77.104c8.516,0,15.422,6.904,15.422,15.422v96.82h30.691v-96.82 c0-8.517,6.906-15.422,15.422-15.422h21.587v-28.095c0-8.517,6.906-15.422,15.422-15.422s15.422,6.904,15.422,15.422v28.095 h21.589c8.516,0,15.422,6.904,15.422,15.422v96.82h88.67c8.516,0,15.422,6.904,15.422,15.422v102.741h0.731 C504.295,327.274,512,292.523,512,256C512,114.841,397.159,0,256,0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.446,284.273h9.253v-61.591c-24.167,6.753-41.947,28.971-41.947,55.264v80.794h17.272v-59.045 C74.024,291.177,80.93,284.273,89.446,284.273z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.973,284.273h8.5V256c0-8.517,6.906-15.422,15.422-15.422h22.338V159.18h-46.26V284.273z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.635,
    y: 271.422,
    width: 73.253,
    height: 87.319
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.317,271.422v12.851h29.804c8.516,0,15.422,6.904,15.422,15.422v59.045h23.227v-87.318H212.317z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.867,
    y: 315.111,
    width: 121.831,
    height: 43.628
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.611,
    y: 159.183,
    width: 43.176,
    height: 199.557
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCity);
export default __webpack_public_path__ + "static/media/city.11ea08e6aed3bb023dc67226b4f9d346.svg";
export { ForwardRef as ReactComponent };